/* Ability Warehouse v3: hero autoplay (2s), two-pane mega menu */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  $$('[data-hero]').forEach(function (hero) {
    var img = $('.hero__media img', hero);
    var thumbs = $$('[data-hero-thumb]', hero);
    if (thumbs.length < 2) return;
    var idx = Math.max(0, thumbs.findIndex(function (b) { return b.classList.contains('is-active'); }));
    var timer = null, reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* Autoplay only while the hero is on screen: no image swaps (and image downloads) once the shopper has scrolled away */
    var onScreen = true;
    function go(i) {
      idx = (i + thumbs.length) % thumbs.length;
      if (img) { img.classList.add('is-fading'); setTimeout(function () { img.classList.remove('is-fading'); }, 350); }
      /* Non-bubbling click: switches the slide (listeners sit on the thumb itself) without reaching document-level
         "click outside to close" handlers — a bubbling .click() here closed the mobile search, mega menu and dropdowns every 2s. */
      thumbs[idx].dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true }));
    }
    function start() { if (reduce || timer || !onScreen || document.hidden) return; timer = setInterval(function () { go(idx + 1); }, 2000); }
    function stop() { clearInterval(timer); timer = null; }
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { idx = i; }); });
    hero.addEventListener('mouseenter', stop); hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop); hero.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { onScreen = en[en.length - 1].isIntersecting; if (onScreen) start(); else stop(); }).observe(hero);
    start();
  });
  $$('[data-mega-dept]').forEach(function (li) {
    var id = li.getAttribute('data-mega-dept');
    function activate() {
      $$('[data-mega-dept]').forEach(function (x) { x.classList.toggle('is-active', x === li); });
      $$('[data-mega-pane]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-mega-pane') === id); });
    }
    li.addEventListener('mouseenter', activate);
    li.addEventListener('focusin', activate);
  });
  /* "Every product" is not a department: hovering it clears the department highlight so only one row is lit; the last pane stays visible. When the mouse leaves the menu, the department that owns the visible pane is re-lit. */
  var megaAll = $('.mega__dept--all'), megaWrap = $('[data-mega]');
  if (megaAll) {
    function clearDepts() { $$('[data-mega-dept]').forEach(function (x) { x.classList.remove('is-active'); }); }
    megaAll.addEventListener('mouseenter', clearDepts);
    megaAll.addEventListener('focusin', clearDepts);
    if (megaWrap) megaWrap.addEventListener('mouseleave', function () {
      if ($('[data-mega-dept].is-active')) return;
      var pane = $('[data-mega-pane].is-active'), id = pane && pane.getAttribute('data-mega-pane');
      var li = id && $('[data-mega-dept="' + id + '"]'); if (li) li.classList.add('is-active');
    });
  }

  /* Drawer levels */
  var dw = $('[data-dw]');
  if (dw) {
    var levels = $$('[data-dw-level]', dw);
    function show(name) {
      levels.forEach(function (l) {
        var on = l.getAttribute('data-dw-level') === name;
        l.classList.toggle('is-active', on);
        l.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) { var sc = $('.dw__scroll', l); if (sc) sc.scrollTop = 0; }
      });
    }
    dw.addEventListener('click', function (e) {
      var go = e.target.closest('[data-dw-go]');
      if (go) { show(go.getAttribute('data-dw-go')); return; }
      var back = e.target.closest('[data-dw-back]');
      if (back) { var lvl = back.closest('[data-dw-level]'); show(lvl.getAttribute('data-dw-parent') || 'root'); }
    });
    var menu = $('[data-menu]');
    if (menu) new MutationObserver(function () { if (menu.hidden) show('root'); }).observe(menu, { attributes: true, attributeFilter: ['hidden'] });
  }

  /* Product trust cards: "Ask about this product" opens the assistant; "Read reviews" scrolls to the reviews section */
  document.addEventListener('click', function (e) {
    var ask = e.target.closest('[data-wiz-open]');
    if (ask) { var w = document.querySelector('.wiz__launch'); if (w) w.click(); return; }
    var rv = e.target.closest('[data-ptc-reviews]');
    if (rv) { var s = document.querySelector('[id$="__reviews"], #shopify-section-reviews'); if (s) { e.preventDefault(); s.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }
  });

  /* Sticky specs column: if it is taller than the viewport, pin its bottom instead so the last card is reachable */
  var col = document.querySelector('.product-details > div:first-child');
  if (col) {
    function pin() {
      if (window.innerWidth < 990) { col.style.top = ''; return; }
      var head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 0;
      var top = head + 16, h = col.offsetHeight, free = window.innerHeight - h - 16;
      col.style.top = (h + top + 16 > window.innerHeight ? free : top) + 'px';
    }
    pin(); window.addEventListener('resize', pin); window.addEventListener('load', pin);
  }

  /* ---------- Price ladder + cart membership ---------- */
  var money = function (c) { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((c || 0) / 100); };
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); });
  }
  function openCart() {
    var o = document.querySelector('[data-cart-open]') || document.querySelector('.header__cart');
    if (o) o.click(); else location.href = '/cart';
  }
  function goMemberCheckout(code) { location.href = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout'; }
  var ladder = $('[data-ladder]');
  if (ladder) {
    var form = document.querySelector('form.calc') || document.querySelector('form[action*="/cart/add"]');
    var qtyOf = function () { var q = form && form.querySelector('[name="quantity"]'); return Math.max(1, parseInt(q && q.value, 10) || 1); };
    var state = { base: +ladder.dataset.base, retail: +ladder.dataset.retail, variant: ladder.dataset.variant, available: true };
    var set = function (sel, txt) { $$(sel, document).forEach(function (e) { e.textContent = txt; }); };
    function compute() {
      var salePct = +ladder.dataset.salePct || 0, mPct = +ladder.dataset.memberPct || 10;
      var ware = Math.round(state.base * (100 - salePct) / 100), member = Math.round(state.base * (100 - mPct) / 100);
      var baseline = state.retail > ware ? state.retail : state.base;
      var q = qtyOf(), items = member * q, wareT = ware * q;
      var fee = 0; /* membership is billed separately in the cart: first month free trial, then $14.99/mo */
      var total = items, net = wareT - total;
      set('[data-l-retail]', money(state.retail * q)); var rr = $('.ladder__row--retail'); if (rr) rr.hidden = !(state.retail > ware);
      set('[data-l-ware], [data-l-ware2]', money(wareT));
      var sw = $('[data-l-save-ware]'); if (sw) { sw.textContent = '−' + money((baseline - ware) * q); sw.hidden = baseline - ware <= 0; }
      set('[data-l-member], [data-l-member3]', money(items));
      set('[data-l-total], [data-l-total2], [data-l-total3]', money(total));
      var nl = $('[data-l-net-line]'); if (nl) nl.textContent = money(wareT - items) + ' less than the price without membership';
      var cta = $('[data-buy-member]'), ok = $('[data-l-consent]'); if (cta) cta.disabled = !state.available;
      var bw = $('[data-buy-ware]'); if (bw) bw.disabled = !state.available;
      return { ware: ware, member: member, q: q };
    }
    compute();
    document.addEventListener('aw:variant', function (e) { var v = e.detail || {}; if (v.id) { state.variant = v.id; state.base = v.price; state.retail = v.compare_at_price || 0; state.available = v.available !== false; } compute(); });
    document.addEventListener('input', function (e) { if (e.target.matches('[name="quantity"]')) compute(); });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-qty-step]')) setTimeout(compute, 0); });
    /* One panel open at a time */
    $$('[data-l-toggle]', ladder).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        $$('[data-l-toggle]', ladder).forEach(function (b) { var on = b === btn && !isOpen; b.setAttribute('aria-expanded', on ? 'true' : 'false'); var p = $('[data-l-panel="' + b.dataset.lToggle + '"]', ladder); if (p) p.hidden = !on; });
      });
    });
    var busy = function (b, on, label) { if (!b) return; b.disabled = on; if (on) { b.dataset.l = b.innerHTML; b.textContent = label; } else if (b.dataset.l) { b.innerHTML = b.dataset.l; } };
    document.addEventListener('click', function (e) {
      /* Member price: adds the product to the cart at member price. Membership is added from the cart. */
      var bm = e.target.closest('[data-buy-member]');
      if (bm) {
        var c = compute();
        busy(bm, true, 'Adding to cart…');
        addItems([{ id: +state.variant, quantity: c.q }]).then(function () { busy(bm, false); openCart(); }).catch(function (err) { busy(bm, false); alert(err.message); });
        return;
      }
      var bw = e.target.closest('[data-buy-ware]');
      if (bw) {
        busy(bw, true, 'Taking you to checkout…');
        addItems([{ id: +state.variant, quantity: qtyOf() }]).then(function () { location.href = '/checkout'; }).catch(function (err) { busy(bw, false); alert(err.message); });
        return;
      }
      var ac = e.target.closest('[data-l-addcart]');
      if (ac) { e.preventDefault(); var hb = form && form.querySelector('[data-add-hidden]'); if (hb) hb.click(); else if (form) form.requestSubmit(); }
    });
  }
  /* Cart: consent gates the membership checkout button */
  document.addEventListener('change', function (e) {
    var c = e.target.closest('[data-mjoin-consent]'); if (!c) return;
    var btn = c.closest('[data-mjoin]').querySelector('[data-mjoin-go]'); if (btn) btn.disabled = !c.checked;
  });
  /* Cart: add the monthly membership (first month free trial, then $14.99/mo) and apply the new-member code, then checkout */
  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-mjoin-go]'); if (!go) return;
    var box = go.closest('[data-mjoin]'); var mv = box.dataset.mvMonthly;
    go.disabled = true; go.textContent = 'Taking you to checkout…';
    addItems([Object.assign({ selling_plan: +box.dataset.planMonthly || undefined }, { id: +mv, quantity: 1, properties: box.dataset.freeMonth === 'true' ? { 'Promo': 'First 2 months free trial' } : { 'Promo': 'First month free trial' } })]).then(function () { goMemberCheckout(box.dataset.code); }).catch(function (err) { go.disabled = false; go.textContent = 'Check out as a member'; alert(err.message); });
  });
})();
